import * as i0 from "@angular/core";
/**
 *
 * Loading Symbol Component
 *
 * Inputs
 *  loaderMessage: The message displayed when showing the loading symbol.
 *
 */
export class LoadingSymbolComponent {
}
LoadingSymbolComponent.ɵfac = function LoadingSymbolComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingSymbolComponent)(); };
LoadingSymbolComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoadingSymbolComponent, selectors: [["ycn-loading-symbol"]], inputs: { loaderMessage: "loaderMessage" }, standalone: false, decls: 3, vars: 1, consts: [[1, "loader"], [1, "loader-message", 3, "textContent"], [1, "loader-spinner"]], template: function LoadingSymbolComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1)(2, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("textContent", ctx.loaderMessage);
    } }, encapsulation: 2, changeDetection: 0 });
